import { createRouter, createWebHistory } from 'vue-router';
import AdminPanel from '../views/AdminPanel.vue';
import UserView from '../views/UserView.vue';
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
import AdminDashboard from '@/views/AdminDashboard.vue';
import ProyectorView from '@/views/ProyectorView.vue';
import PrivacyView from '@/views/PrivacyView.vue';

const esMovil = () => {
  return (
    /android|iphone|ipod/i.test(navigator.userAgent) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};


const routes = [
  { path: '/', component: ProyectorView },
  { path: '/login', component: Login },
  { path: '/admin', component: AdminPanel},
  { path: '/home', component: Home },
  { path: '/view', component: ProyectorView },
  { path: '/user', component: UserView },
  { path: '/privacy', component: PrivacyView },
  // Página dedicada para compartir: solo el reclamo de link.
  // Va ANTES del catch-all '/:slug', que si no la tomaría como un slug de marca.
  { path: '/join', component: UserView },
  { path: '/u/:slug', component: UserView },
  { path: '/chat/:slug', component: UserView },
  { path: '/:slug', component: UserView }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  // Solo en móvil
  if (esMovil()) {

    // Rutas que NO deben ser forzadas
    const rutasExcluidas = ['/user', '/login', '/admin'];

    if (
      (to.path === '/' || to.path === '/home') &&
      !rutasExcluidas.includes(to.path)
    ) {
      next('/user');
      return;
    }
  }

  next();
});


// Exportación por defecto para evitar errores de importación
export default router;
